<div red-chip [attr.redBackground]="redBackground" [attr.redShape]="redShape" [attr.redColor]="redColor"
  [attr.redSize]="redSize">

  <ng-content></ng-content>

</div>